import React from "react";

import { SvgWrapper } from "../styles";

interface SvgComponentProps {
  height: number;
  width: number;
  color: string;
}

const IconUser = (props: SvgComponentProps) => {
  const { width, height, color } = props;

  return (
    <SvgWrapper>
      <svg
        xmlns="http://www.w3.org/2000/svg"
        width={width}
        height={height}
        viewBox={`0 0 ${width} ${height}`}
        fill="none"
      >
        <path
          d="M6 6.375C4.415 6.375 3.125 5.085 3.125 3.5C3.125 1.915 4.415 0.625 6 0.625C7.585 0.625 8.875 1.915 8.875 3.5C8.875 5.085 7.585 6.375 6 6.375ZM6 1.375C4.83 1.375 3.875 2.33 3.875 3.5C3.875 4.67 4.83 5.625 6 5.625C7.17 5.625 8.125 4.67 8.125 3.5C8.125 2.33 7.17 1.375 6 1.375Z"
          fill={color}
        />
        <path
          d="M10.2951 11.375C10.0901 11.375 9.92007 11.205 9.92007 11C9.92007 9.275 8.16008 7.875 6.00008 7.875C3.84008 7.875 2.08008 9.275 2.08008 11C2.08008 11.205 1.91008 11.375 1.70508 11.375C1.50008 11.375 1.33008 11.205 1.33008 11C1.33008 8.865 3.42508 7.125 6.00008 7.125C8.57508 7.125 10.6701 8.865 10.6701 11C10.6701 11.205 10.5001 11.375 10.2951 11.375Z"
          fill={color}
        />
      </svg>
    </SvgWrapper>
  );
};

export default IconUser;
